module.exports = __webpack_public_path__ + "static/media/grin-tears.07bb93e0.svg";